import React, { PropsWithChildren } from "react";
import Skeleton from "react-loading-skeleton";
import { HorizontalLeftAlignedContainer } from "../../styles/container";
import { H1 } from "../../styles/text";
import { useNavigation } from "react-router-dom";

type PrimaryLeftHeaderProps = {
  width?: number;
};

export const PrimaryLeftHeader = (
  props: PropsWithChildren<PrimaryLeftHeaderProps>
) => {
  const { width, children } = props;
  const navigation = useNavigation();
  const skeletonWidth = width
    ? width
    : children
    ? children.toString().length * 20
    : 250;
  return (
    <>
      <HorizontalLeftAlignedContainer>
        {navigation.state === "loading" ? (
          <Skeleton height={28} width={skeletonWidth} />
        ) : (
          <H1>{children}</H1>
        )}
      </HorizontalLeftAlignedContainer>
    </>
  );
};
